export default {"src":"/_next/static/media/topic-eciu.f33b88bd.svg","height":209,"width":208,"blurWidth":0,"blurHeight":0};